import React from 'react';
import { Spinner } from '../Spinner/Spinner';
import css from './LoadingOverlay.module.scss';

interface LoadingOverlayProps {
    isOpen: boolean;
    message?: string;
    currentFile?: number;
    totalFiles?: number;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isOpen, message, currentFile, totalFiles }) => {
    if (!isOpen) return null;
    const progressPercentage = currentFile && totalFiles ? Math.round((currentFile / totalFiles) * 100) : 0;

    return (
        <div className={css.overlay}>
            <div className={css.content}>
                <Spinner size={4} />
                {message && <div className={css.message}>{message}</div>}
                {currentFile !== undefined && totalFiles !== undefined && (
                    <div className={css.progressContainer}>
                        <div className={css.progressBar}>
                            <div className={css.progressFill} style={{ width: `${progressPercentage}%` }} />
                        </div>
                        <div className={css.progressText}>
                            {currentFile} / {totalFiles} ({progressPercentage}%)
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
